import React from 'react';
import { FindAllInspectorStatisticsResponse } from '@ansvar-sakerhet/api-client';

import { S } from './InspectorStatisticsTable.styles';

type Props = {
  statistics: FindAllInspectorStatisticsResponse[];
};

export const InspectorStatisticsTable: React.FC<Props> = ({ statistics }) => {
  if (!statistics.length) {
    return null;
  }

  return (
    <S.Container>
      <S.H6>Kontroller per kontrollant</S.H6>
      <S.Margin $spacing="xs" />

      <S.Table>
        <S.THead>
          <S.THeadRow>
            <S.THeadCell>Kontrollant</S.THeadCell>
            <S.THeadCell>Antal</S.THeadCell>
          </S.THeadRow>
        </S.THead>

        <S.TBody>
          {statistics.map((row) => (
            <S.TBodyRow key={row.scannedEmail ?? 'ej-kontrollerad'}>
              <S.TBodyCell>
                {row.scannedEmail ?? 'Ej kontrollerad'}
              </S.TBodyCell>
              <S.TBodyCell>{row.count}</S.TBodyCell>
            </S.TBodyRow>
          ))}
        </S.TBody>
      </S.Table>
    </S.Container>
  );
};
